import React, { useMemo } from 'react';
import { useAgency } from "../../providers/AgencyProvider";
import CircleProgress from "../../components/CircleProgress";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import InfoTooltip from "../../components/InfoTooltip";
import { Tooltip } from "antd";
import { PictureOutlined } from "@ant-design/icons";
// import AgencyMatchDetails from "./AgencyMatchDetails";

const AgencyHorizontalTile = (props) => {
    const { agency, canFavorite, criteria, removeFromFavorites, addToFavorites } = useAgency();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    // const vips = TB.filter(agency.topPositionsForDisplay(), vip => TB.isDefined(vip)).map(vip => User.make({ ...vip }));


    const agencyMemberLink = useMemo(() => {
        const params = { agency_id: agency.id }

        const state = {
            linkParams: {
                title: 'Back',
                path: location.pathname + (location.search || '')
            }
        }
        return { state, params }
    }, [agency, location.pathname]);


    const showMatchDetails = () => {
        let matchCriteria = {};
        if (criteria) {
            matchCriteria = criteria;
        }

        // return TB.event('Modal@show', {
        //     modalClass: 'match-details-modal',
        //     content: (
        //         <AgencyMatchDetails
        //             agency={agency}
        //             isEngagementLead={false}
        //             criteria={matchCriteria}
        //         />
        //     )
        // })
    }

    const detailLink = useMemo(() => {
        let params = new URLSearchParams(searchParams);

        return {
            pathname: `agency-profiles/${agency.id}`,
            search: params.size > 0 ? `?${params.toString()}` : undefined
        }
    }, [searchParams?.toString()])
    const tooltipId = `${agency?.id}-browse`
    const favoriteId = "fav-btn-" + tooltipId;

    const MAX_EXAMPLE_CLIENTS = 5;

    const clientExampleBrands = agency.brands

    const SERVICES = [
        { id: 1, name: 'Digital Marketing' },
        { id: 2, name: 'Ecommerce Sites' },
        { id: 3, name: 'Paid Search Progams' },
        { id: 4, name: 'Video Editor' },
        { id: 5, name: 'Graphic Designer' },
    ]

    return (
        <div className="team-horizontal-tile p-4 pb-0 mb-8 bg-wrippleOffWhite">

            <div className="bg-white w-full">
                <div className="p-4 md:flex justify-between md:space-x-12 border-b border-[#CECECE]">

                    <div className="w-full flex justify-between">

                        <div className="flex gap-3 w-full">
                            <img src={agency.logo_path} alt="" className="h-52 w-52" />
                            <div className="pl-2 w-full">
                                <div className="flex justify-between w-full pb-2">
                                    <p className="text-2xl font-bold">{agency.name}</p>
                                    <Link className="details-link text-xs md:text-sm" to={detailLink}>
                                        View Agency
                                    </Link>
                                </div>
                                <p className="text-sm line-clamp-3 pt-2">{TB.stripHtml(agency?.about)}</p>

                                <div className="flex items-center gap-6 pt-6">

                                    <div className="flex items-center my-1 gap-2">
                                        <i className="fas fa-map-marker-alt" />
                                        <p className="text-sm leading-4 text-[#224760]">{agency.location.city}{!!agency.location.state && `, ${agency.location.state}`}</p>
                                    </div>
                                    {agency.locations?.length && (
                                        <p className="text-gray-500">+{TB.pluralize(agency.locations.length, 'location', true)}</p>
                                    )}
                                    {/* <p className="text-sm text-gray-500">Under 50 employees</p> */}
                                    <p className="text-gray-500">{laravel.client_sizes[agency.size]}</p>
                                    <a className="text-sm btn-link" href={agency.website} target="_blank">{agency.website}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-blue100 p-4 flex divide-x gap2 [&>div]:px-4 [&>div:first-child]:pl-0 [&>div:last-child]:pr-0 [&>div:last-child]:bgred-200">

                    {/* <div className="wfull mdw-1/3 md:border-r pb-3 border-[#CECECE] flex md:flex-col justify-center gap-4">
                        <div className="h-full flex justify-center">
                            <CircleProgress
                                className="metric-circle self-center w-20"
                                progress={agency.overallMatchPercent()}
                                strokeWidth={7}
                            >
                                <p className="-mt-1">
                                    <span className="text2xl">{agency.overallMatchPercent(true)}%</span>
                                    <small className="text-xs">Match</small>
                                </p>
                            </CircleProgress>
                        </div>

                        <button type="button" className="details-link" onClick={showMatchDetails}>More</button>
                    </div> */}

                    {/* <div className="wfull mdw-1/3 md:borderr pb-3 border-[#CECECE] flex md:flex-col justify-center gap-4">
                        <div className="h-full flex justify-center">
                            <CircleProgress
                                className="metric-circle self-center w-28"
                                progress={agency.overallMatchPercent()}
                                strokeWidth={7}
                            >
                                <p className="-mt-1">
                                    <span className="text-xl">{agency.overallMatchPercent(true)}%</span>
                                    <small className="text-base">Match</small>
                                </p>
                            </CircleProgress>
                        </div>

                    </div> */}


                    {/* <div className="w-full"> */}
                    <div className="w-3/5">
                        <p className="text-base pb-2">Services</p>

                        <div className="flex gap-3 flex-wrap items-start">
                            {agency.service_offerings.length ? (
                                <>
                                    {TB.map(agency.service_offerings.slice(0, MAX_EXAMPLE_CLIENTS), discipline => (
                                        <div key={discipline.id}
                                            className="flex flex-col items-center justify-center text-center max-w-2/3 border border-secondary rounded-lg p-2 pb-1">
                                            <p className="text-xs font-bold text-ellipsis line-clamp-2">{discipline.name}</p>
                                            {/* <p className="text-xxs text-[#3E3F42]">{laravel.talent_scoring_options[discipline.self_score]}</p> */}
                                        </div>
                                    ))}

                                    {(agency.service_offerings.length - MAX_EXAMPLE_CLIENTS) > 0 && (
                                        <div className="flex justify-center items-center border border-secondary rounded-lg p-2 pb-1">
                                            <p className="text-xs font-bold text-ellipsis line-clamp-2">+{agency.service_offerings.length - MAX_EXAMPLE_CLIENTS} more</p>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <p className="text-gray-500 text-xs">No Services Available</p>
                            )}
                        </div>
                    </div>


                    {/* <div className="w1/3 min-w-[327px]"> */}
                    <div className="w-2/5">
                        <p className="text-base pb-2">Client Examples</p>

                        {clientExampleBrands.length ? (
                            <div className="grid grid-cols2 gap-2 grid-cols-[98px_98px_98px]">
                                {TB.map(clientExampleBrands.slice(0, MAX_EXAMPLE_CLIENTS), brand => (
                                    <ProfileBrand key={brand.id} brand={brand} tooltipPlacement="bottom" />
                                ))}

                                {(clientExampleBrands.length - MAX_EXAMPLE_CLIENTS) > 0 && (
                                    <div className="flex justify-center items-center">
                                        <p>+{clientExampleBrands.length - MAX_EXAMPLE_CLIENTS} more</p>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p className="text-gray-500 text-xs">No Examples Available</p>
                        )}

                    </div>
                </div>


                <div className="bg-wrippleOffWhite p-4 flex justify-between mdspace-x-12">
                    {/* <div className="flex gap-4 items-center">
                        <p className="text-2xl">Budget Range</p>

                        <div className="flex flex-col">
                            <p>Monthly Retainer: {TB.formatCurrency(10000)} - {TB.formatCurrency(100000)}</p>
                            <p>Project Work: {TB.formatCurrency(10000)} - {TB.formatCurrency(100000)}</p>
                        </div>
                    </div> */}

                    <div className="flex items-center gap-6">
                        <p className="text-xl font-semibold text-wrippleAlternateDarker">
                            Engagement <br />
                            Preferences
                        </p>

                        <div>
                            <p>Project Size (Starting At): {TB.formatCurrency(agency.target_project_budget, false)}</p>
                            <p>Annual Client Spend (Target): {TB.formatCurrency(agency.target_annual_fees, false)}</p>
                        </div>

                    </div>

                    {!props.isBrowse && (
                        <div className="flex items-center justify-center pt-4 md:pt-0 md:w-[30%] gap-4">
                            <button className="btn btn-primary btn-block request-tn text-base min-w[250px] w-full">
                                Connect
                            </button>
                            {/* {props.children || (
                                <button className="btn btn-primary btn-block whitespace-nowrap request-tn text-base min-w[250px] w-full">
                                    Invite to Project
                                </button>
                            )} */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AgencyHorizontalTile;

const Brand = ({ brand, children, className = '' }) => {
    const imagePath = brand.logo || brand.logo_path || brand.icon || brand.icon_path || brand.image_path
    return (
        <div className={TB.mapClass("pointer-events-auto flex items-center justify-center relative py-3 max-w-[100px] h-[70px] w-[100px] px-3 w36 min-w36 h28 border border-gray-200 rounded-lg", {
            [className]: true
        })}>
            {/* Checker pattern background */}
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-gray-300 opacity-50" />

            {/*Extra content*/}
            {children}

            <div className="relative overflow-hidden flex items-center justify-center">
                {imagePath ? (
                    <img
                        className="h-full max-h24 w-full max-w32 object-contain"
                        src={imagePath}
                        alt={brand.name}
                    />
                ) : (
                    <PictureOutlined className="w-full max-w-full" style={{ fontSize: 56 }} />
                )}
            </div>
        </div>
    )
}

const ProfileBrand = ({ brand, className = '', showTooltip = true, isDisabled, tooltipPlacement = 'top', children, ...props }) => {
    let brandClass = className;
    if (isDisabled) {
        brandClass += ' grayscale';
    }
    if (!showTooltip) {
        return (
            <Brand
                key={props.key || undefined}
                brand={brand} className={brandClass}>
                {children}
            </Brand>
        )
    }
    return (
        <Tooltip
            key={props.key || undefined}
            placement={tooltipPlacement}
            title={(
                <div className="flex flex-col gap-1">
                    <p className="text-xs text-white">{brand.name || brand.domain || brand.headline}</p>
                    {brand.name && brand.domain && (
                        <p className="text-xs text-info whitespace-nowrap">
                            {brand.domain}
                        </p>
                    )}
                </div>
            )}
        >
            {/* <div> */}
            <Brand brand={brand} className={isDisabled ? 'grayscale opacity-60' : ''}>
                {children}
            </Brand>
            {/* </div> */}
        </Tooltip>
    )
};